import "./components/product-grid/go-to-products";
import "./components/product-grid/search-view";
import "./components/product-grid/elastic-search-view";

if (document.querySelector(".filter-categories")) {
    import("./components/product-grid/search-filter-categories.js").then(
        ({ init }) => init(),
    );
}

if (import.meta.hot) {
    import.meta.hot.accept();
}
